// extracted by mini-css-extract-plugin
export var barLeft = "hero-module--barLeft--5b270";
export var barRight = "hero-module--barRight--2f435";
export var bars = "hero-module--bars--71896";
export var button = "hero-module--button--768e4";
export var scrolling = "hero-module--scrolling--713b8";
export var section = "hero-module--section--83a37";
export var subtitle = "hero-module--subtitle--cd77d";
export var title = "hero-module--title--7a9fe";